import FastlyImageOptimizerPlaygroundPage from "@faire/prototype-playground/workspace/bh/fastly-image-optimizer";
import PrepackSelectorPage from "@faire/prototype-playground/workspace/bh/prepack-selector";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const ImageUpscalingPage = lazy(() => import("../../pages/ImageUpscalingPage"));
const RetailerLayout = withCompass(
  () => import("../../components/RetailerLayout")
);

export function BenHamiltonRoutes() {
  return (
    <Switch>
      <Route
        path="/bh/fastly-image-optimizer"
        component={FastlyImageOptimizerPlaygroundPage}
      />
      <Route path="/bh/image-upscaling" component={ImageUpscalingPage} />
      <Route
        path="/bh/prepack-selector"
        render={() => (
          <RetailerLayout>
            <PrepackSelectorPage />
          </RetailerLayout>
        )}
      />
    </Switch>
  );
}

export const slug = "bh";
